import { render, staticRenderFns } from "./RequeteDashboardCard.vue?vue&type=template&id=2b46e798&"
import script from "./RequeteDashboardCard.vue?vue&type=script&lang=js&"
export * from "./RequeteDashboardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports